import { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { ThemeProvider } from "@/components/theme/ThemeProvider";

const CursorParticles = lazy(() => import("@/components/feature/CursorParticles"));

function App() {
  const [showCursorParticles, setShowCursorParticles] = useState(false);

  useEffect(() => {
    const idleWindow = window as Window & {
      requestIdleCallback?: (
        callback: IdleRequestCallback,
        options?: IdleRequestOptions
      ) => number;
      cancelIdleCallback?: (id: number) => void;
    };
    const canRenderCursorFx =
      window.innerWidth >= 1024 &&
      window.matchMedia("(pointer: fine)").matches &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!canRenderCursorFx) return;

    const activate = () => setShowCursorParticles(true);

    if (idleWindow.requestIdleCallback && idleWindow.cancelIdleCallback) {
      const idleId = idleWindow.requestIdleCallback(activate, { timeout: 1200 });
      return () => idleWindow.cancelIdleCallback?.(idleId);
    }

    const timeoutId = window.setTimeout(activate, 900);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <ThemeProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <Suspense fallback={null}>
          {showCursorParticles ? <CursorParticles /> : null}
        </Suspense>
        <AppRoutes />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
